require('default-passive-events');  // 一劳永逸的帮助我们解决 warnings: marking event handlers as passive.
import _ from 'lodash';  // lodash 只需要全局导入一次，然后它便作为公共的标识符`_`供所有的模块使用，也就是说其他模块不用再倒入了。
import Vue from 'vue';
import App from './App';
import store from './store';
import router from './router';
import Vue2TouchEvents from 'vue2-touch-events'
import ElementUI from 'element-ui';
import Avatar from "./components/commons/Avatar";
import Slogan from "./components/Slogan";
import MyLink from "./components/commons/MyLink";
import MyDivider from "./components/commons/MyDivider";
import IconfontSelector from "./components/commons/IconfontSelector";
import IconfontSelectorTooltip from "./components/commons/IconfontSelectorTooltip";
import IconText from "./components/commons/IconText";
import Loading from "./components/commons/Loading";
import NoSignal from "./components/commons/NoSignal";
import Tipoff from "./components/commons/Tipoff";
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/iconfont/iconfont.css';
import './assets/site.css';

Vue.use(Vue2TouchEvents);
Vue.use(ElementUI);
Vue.component(Avatar.name, Avatar);
Vue.component(Slogan.name, Slogan);
Vue.component(MyLink.name, MyLink);
Vue.component(MyDivider.name, MyDivider);
Vue.component(IconfontSelector.name, IconfontSelector);
Vue.component(IconfontSelectorTooltip.name, IconfontSelectorTooltip);
Vue.component(IconText.name, IconText);
Vue.component(Loading.name, Loading);
Vue.component(NoSignal.name, NoSignal);
Vue.component(Tipoff.name, Tipoff);

// import VConsole from 'vconsole'
// if (process.env.NODE_ENV === 'hybridapp') {
    // new VConsole();  // 初始化 vconsole
// }

// H5 plus 事件处理
function plusReady(){
    // 验证，是否可以通过 hybrid app 的模式获取 www.huocool.com.cn 中的 cookies，验证结果是不行。
    // let cookies = plus.navigator.getCookie('https://www.huocool.com.cn');
    // console.log('page init: the cookie is', cookies);
    console.log('user agent is', plus.navigator.getUserAgent());
    // plus.storage.clear();
    // console.log('storage get purged');
    // alert(`plus ready, ${plus.navigator.getUserAgent()}`);
    // ==== 常亮设置 ====
    // 在播放视频的时候才设置，现在的做法是，初始化 VideoPlayer 的时候设置为常亮，当 VideoPlayer 被销毁的时候（即是离开）取消常亮设置。
    // plus.device.setWakelock(true); // 设置屏幕保持常亮。
}

// 判断runtime是否支持5+ API
if(navigator.userAgent.indexOf("Html5Plus") < 0){//不支持5+ API
    // alert("不支持5+ API");
}else{//支持5+ API
    // alert("支持5+ API");
}

if(window.plus){
    plusReady();
}else{
    document.addEventListener('plusready', plusReady, false);
}

Vue.config.productionTip = false;
// 创建 EventBus，原理便是，利用一个没有 DOM 的 Vue 实例来发出事件，接收方同样利用该实例接收事件。
Vue.prototype.$EventBus = new Vue();

/* eslint-disable no-new */
export const vue = new Vue({
    el: '#app',
    store,
    router,
    render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/main.js